import gql from 'graphql-tag';

const query = gql`
    query MeAccessTo {
        me {
            id
            diet {
                accessTo
            }
        }
    }
`;

export default query;
